import React from "react";
import Amini from "../../assets/amini.jpg";
import Hussain from "../../assets/hussain.png";
import Nabizada from "../../assets/nabizada.jpg";

const RolesAndActivities = () => {
  // Mock data for experts to make code clean and scalable
  const expertsList = [
    {
      id: 1,
      name: "Mir Ahmad Nabizada",
      role: "CEO",
      img: Nabizada,
    },
    {
      id: 2,
      name: "Ebadullah Amini",
      role: "Developer",
      img: Amini,
    },
    {
      id: 3,
      name: "Husain Haidarzada",
      role: "Developer",
      img: Hussain,
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* --- Left Column: Content --- */}
          <div className="px-5 flex flex-col items-start max-w-2xl">
            {/* Badge */}
            <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-blue-600 text-sm font-semibold tracking-wide uppercase mb-4">
              Our Core Activities
            </span>

            {/* Main Title */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.1] tracking-tight mb-6">
              Roles and Activities <br />
              <span className="text-blue-600">of Yarqin Tech Hub</span>
            </h1>

            <p className="text-lg text-slate-600 leading-relaxed max-w-md mb-8">
              Our marketing and market analysis team uses advanced data insights
              and research to empower technology companies:
            </p>

            {/* List of Activities (Added to fill content) */}
            <ul className="space-y-4 mb-10 text-slate-700">
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-blue-500 mr-3 mt-1 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <span>Strategic Market Analysis & Competitor Research</span>
              </li>
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-blue-500 mr-3 mt-1 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <span>Comprehensive Branding & Accreditation Services</span>
              </li>
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-blue-500 mr-3 mt-1 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <span>Connecting Startups with International Ecosystems</span>
              </li>
            </ul>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
              <a
                href="/contact"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3.5 rounded-full font-bold transition-all shadow-lg hover:shadow-blue-500/30 text-center"
              >
                Contact Us
              </a>
            </div>
          </div>

          {/* --- Right Column: Image & Floating Experts Card --- */}
          <div className="relative group">
            {/* Main Image */}
            <div className="relative w-full aspect-[4/3] rounded-[2.5rem] overflow-hidden shadow-2xl border border-slate-100">
              <img
                // Replace {Meeting1} with your actual image import
                src="https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
                alt="Team Activities"
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
            </div>

            {/* Floating Experts Card */}
            <div className="hidden md:block absolute bottom-6 left-6 lg:bottom-8 lg:left-8 bg-white/95 backdrop-blur-xl p-6 rounded-2xl shadow-2xl max-w-[280px] w-full border border-slate-100">
              <h3 className="font-bold text-slate-900 mb-5 text-lg">
                Our Verified Experts
              </h3>

              <div className="flex flex-col gap-4">
                {expertsList.map((expert) => (
                  <div key={expert.id} className="flex items-center gap-3">
                    <img
                      src={expert.img}
                      alt={expert.name}
                      className="w-12 h-12 rounded-full object-cover border-2 border-slate-100"
                    />
                    <div>
                      <p className="text-sm font-bold text-slate-900 leading-none">
                        {expert.name}
                      </p>
                      <p className="text-xs text-slate-500 mt-1 font-medium">
                        {expert.role}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Decorative Blob behind */}
            <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-blue-50 rounded-full mix-blend-multiply filter blur-3xl opacity-60 -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RolesAndActivities;
